import { createAction } from '@reduxjs/toolkit';

export const fetchLoggedUser = {
  pending: createAction('user/fetchLoggedUser/pending'),
  fulfilled: createAction<any>('user/fetchLoggedUser/fulfilled'),
  rejected: createAction<Error>('user/fetchLoggedUser/rejected'),
}

export const fetchGoogleAccounts = {
  pending: createAction('user/googleAccount/pending'),
  fulfilled: createAction<any>('user/googleAccount/fulfilled'),
  rejected: createAction<Error>('user/googleAccount/rejected'),
}
